<script>
	export let data;
	import { cloneDeep } from "lodash-es";
	import { isNewDataChanged } from "../../../../stores/variables";

	function add2() {
		let temp = ["", ""];
		data.values[data.values.length] = temp;
		data = data;
	}
	function remove(i) {
		$isNewDataChanged = true;
		data.values.splice(i, 1);
		data = data;
	}
	function updateData() {
		$isNewDataChanged = true;
		data.exitValue = cloneDeep(data.values);
		data.exitValue.forEach((arr_value, i) => {
			data.exitValue[i] = arr_value.join("|||");
		});
		data.exitValue = data.exitValue.join("^^^");
		data.newData[data.field_name] = data.exitValue;
	}

	if (data) {
		if (!data.newData) data.newData = [];
		if (!data.values) data.values = [["", ""]];
		if (data.newData && data.newData[data.field_name]) {
			data[data.field_name] = cloneDeep(data.newData[data.field_name]);
			data.values = data[data.field_name].split("^^^");
			data.values.forEach((raw, i) => {
				data.values[i] = raw.split("|||");
			});
			data = data;
		}
	}
</script>

{#if data.name}
	<h3>{data.name}</h3>
{/if}

{#if data}
	<div class="information">
		{#if data.values}
			{#each data.values as item, i}
				<div class="information__item">
					<label
						class={"information__label input__wrap information__label0"}
					>
						<input
							type="tel"
							bind:value={item[0]}
							on:input={() => {
								updateData();
							}}
							maxlength="4"
						/>
						<span class={item[0] ? "active" : ""}>{"Год"}</span>
					</label>
					<label
						class={"information__label information__label-comment input__wrap information__label1"}
					>
						<input
							type="text"
							bind:value={item[1]}
							on:input={() => updateData()}
						/>
						<span class={item[1] ? "active" : ""}>{"Название"}</span
						>
					</label>
					{#if data.values.length < 2}
						<button
							type="button"
							class="form__add"
							on:click={() => add2()}
							><i class="fas fa-times" /></button
						>
					{:else}
						<button
							type="button"
							class="form__remove"
							on:click={() => remove(i)}
							><span><i class="fas fa-times" /></span></button
						>
						{#if data.values.length == i + 1}
							<button
								type="button"
								class="form__add"
								on:click={() => add2()}
								><i class="fas fa-times" /></button
							>
						{:else}
							<div class="form__blank" />
						{/if}
					{/if}
				</div>
			{/each}
		{/if}
	</div>
{/if}

<style lang="scss">
	.information {
		display: flex;
		flex-direction: column;
		max-width: var(--module-width-1);
		&__item {
			display: flex;
			margin-bottom: 16px;

			@media (max-width: 991px) {
				position: relative;
				flex-direction: column;
			}
		}
		&__label {
			&:first-child {
				margin: 0 16px 0 0;
			}
			&-comment {
				flex-grow: 1;
			}

			> input {
				width: 100%;
			}

			@media (min-width: 992px) {
				&0 {
					width: 100px;
				}
			}
			&1 {
				width: 100%;
			}

			@media (max-width: 991px) {
				&:first-child {
					margin: 0 0 16px 0;
				}
				> input {
					width: 100%;
					margin: 0 60px 0 0;
				}
			}
		}
	}
</style>
